export const ADD_PERMISSIONS = 'ADD_PERMISSIONS'
export const ADD_PERMISSION = 'ADD_PERMISSION'
export const UPDATE_PERMISSION = 'UPDATE_PERMISSION'
export const DELETE_PERMISSION = 'DELETE_PERMISSION'
export const ADD_USER_DATA = 'ADD_USER_DATA'
